import styled from 'styled-components';

export const SelectButton = styled.div`
  width: 100%;
  cursor: pointer;
`;
